import { Link } from 'react-router-dom';
import Privacy from '../privacy/privacy';
import { useT } from '../i18n/i18n';

export default function PrivacyPage() {
  const t = useT();
  return (
    <section aria-labelledby="privacy-h" style={{ maxWidth: 760, margin: '0 auto' }}>
      <div className="card">
        <h2 id="privacy-h">{t('Privacy')}</h2>
        <Privacy />
        <div className="toolbar">
          <Link className="btn secondary" to="/">{t('Back')}</Link>
        </div>
      </div>
    </section>
  );
}
